import { render, staticRenderFns } from "./jianyanServiceDetail.vue?vue&type=template&id=c6e14f78&scoped=true"
import script from "./jianyanServiceDetail.vue?vue&type=script&lang=js"
export * from "./jianyanServiceDetail.vue?vue&type=script&lang=js"
import style0 from "./jianyanServiceDetail.vue?vue&type=style&index=0&id=c6e14f78&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6e14f78",
  null
  
)

export default component.exports